import React, { useState } from 'react';
import ConverterLayout from '../JsonTools/ConverterLayout'; // Reusing the layout
import { Alert } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';
import ToolPageContainer from '../../components/ToolPageContainer';

function Base64EncoderDecoder() {
  const [plainText, setPlainText] = useState('Hello World');
  const [base64, setBase64] = useState('SGVsbG8gV29ybGQ=');
  const [error, setError] = useState('');
  const [isEncoding, setIsEncoding] = useState(true);

  const handleConvert = () => {
    setError('');
    try {
      if (isEncoding) {
        if (!plainText.trim()) {
          setBase64('');
          return;
        }
        setBase64(btoa(unescape(encodeURIComponent(plainText))));
      } else {
        if (!base64.trim()) {
          setPlainText('');
          return;
        }
        setPlainText(decodeURIComponent(escape(atob(base64))));
      }
    } catch (e) {
      setError('Invalid input string.');
    }
  };

  const handleSwap = () => {
    setIsEncoding(!isEncoding);
    setError('');
  };

  const handleClear = () => {
    setPlainText('');
    setBase64('');
    setError('');
  };

  return (
    <>
      <SEO
        title="Base64 Encoder & Decoder | Text Tools | UmbrellaCo"
        description="Encode and decode text to and from Base64 format online. Secure, client-side conversion tool for developers."
        keywords="base64 encoder, base64 decoder, text to base64, decode base64 string, online base64 tool"
        url="/text-tools/base64"
        jsonLd={createSoftwareAppSchema(
          'Base64 Encoder Decoder',
          'Securely encode and decode text using Base64 directly in your browser.',
          'https://umbrellaco.in/text-tools/base64',
          ['Text Encoding', 'Base64', 'Developer Utilities']
        )}
      />
      <ToolPageContainer
        title="Base64 Encoder / Decoder"
        description="Easily convert plain text into Base64 encoded strings or decode Base64 data back to its original text format."
        disablePadding
      >
      {error && <Alert severity="error" sx={{ mb: 2, mx: 2 }}>{error}</Alert>}
      <ConverterLayout
        title={isEncoding ? "Base64 Encode" : "Base64 Decode"}
        leftTitle={isEncoding ? "Plain Text" : "Base64"}
        rightTitle={isEncoding ? "Base64" : "Plain Text"}
        leftLanguage="plaintext"
        rightLanguage="plaintext"
        leftValue={isEncoding ? plainText : base64}
        setLeftValue={isEncoding ? setPlainText : setBase64}
        rightValue={isEncoding ? base64 : plainText}
        onConvert={handleConvert}
        onSwap={handleSwap}
        onClear={handleClear}
      />
      </ToolPageContainer>
    </>
  );
}

export default Base64EncoderDecoder;